import React from 'react';
import { Input, Form, DatePicker, Button, Row, Col, Icon, Select } from 'antd';
import { removePropertyOfNull } from '../../../utils';

const { TextArea } = Input;
const { RangePicker } = DatePicker;
const { Option } = Select;

const Render = ({ form, onFinish }) => {
	const formLargeItemLayout = {
		labelCol: {
			span: 4,
		},
		wrapperCol: {
			span: 18,
		},
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		form.validateFields((err, values) => {
			if (!err) {
				// 清空一下空数据
				onFinish(removePropertyOfNull(values));
			}
		});
	};

	const reset = (e) => {
		form.resetFields();
	};

	return (
		<Form {...formLargeItemLayout}>
			<Row gutter={24}>
				<Col span={6}>
					{/* 将产品的选择框放在第一个位置 */}
					<Form.Item label="产品">
						{form.getFieldDecorator('guarantee_type', { initialValue: '0' })(
							<Select style={{ width: '100%', color: 'blue' }}>
								<Option key="0" value="0">
									企信宝
								</Option>
								<Option key="1" value="1">
									大经宝
								</Option>
							</Select>
						)}
					</Form.Item>
				</Col>
				<Col span={6}>
					<Form.Item label="客户名称">
						{form.getFieldDecorator('cust_name', {})(<Input placeholder="客户名称" />)}
					</Form.Item>
				</Col>
				<Col span={6}>
					<Form.Item label="分公司">
						{form.getFieldDecorator('subcompany', {})(<Input placeholder="分公司" />)}
					</Form.Item>
				</Col>
				<Col span={6}>
					<Form.Item label="客户编码">
						{form.getFieldDecorator('sap_no', {})(<Input placeholder="客户编码" />)}
					</Form.Item>
				</Col>
			</Row>
			{/* 调整按钮样式 */}
			<Row style={{ marginRight: '30px', marginBottom: '5px' }}>
				<Col align={'right'}>
          <span display={'inline'}>
            <Button type="primary" onClick={handleSubmit}>
              <Icon type="search" /> 查询
            </Button>
            <Button type="default" onClick={reset}>
              <Icon type="redo" /> 重置
            </Button>
          </span>
				</Col>
			</Row>
		</Form>
	);
};

const SearchRender = Form.create()(Render);

export default SearchRender;
